/*======================================================================================================================
  * Bluebell: src/app/state/postpro-settings/postpro-settings.reducer.ts
  * Last Edited: 23/05/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createReducer, on } from '@ngrx/store';
import { programmeProjectSelectionUnapplied } from '@state/account/account.actions';
import {
  loadPostproSettings,
  loadPostproSettingsFailure,
  loadPostproSettingsSuccess, savePostproSettings, savePostproSettingsFailure, savePostproSettingsSuccess,
} from '@state/postpro-settings/postpro-settings.actions';
import { PostproSettings } from '@state/postpro-settings/postpro-settings.interfaces';


export interface State {
  loadedSettings: PostproSettings|null;
  loading: boolean;
}

export const initialState: State = {
  loadedSettings: null,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(programmeProjectSelectionUnapplied, () => {
    return { ...initialState };
  }),

  on(
    loadPostproSettings,
    savePostproSettings,
    (state) => {
    return {
      ...state,
      loading: true,
    };
  }),

  on(
    loadPostproSettingsSuccess,
    savePostproSettingsSuccess,
    (state, { loadedSettings }) => {
    return {
      ...state,
      loading: false,
      loadedSettings,
    };
  }),

  on(
    loadPostproSettingsFailure,
    savePostproSettingsFailure,
    (state) => {
    return {
      ...state,
      loading: false,
    };
  }),

);



export const featureKey = 'postproSettings';
export const getLoadedSettings = (state: State) => state.loadedSettings;
export const getLoading = (state: State) => state.loading;
